import { trackClickEvent } from "utils/trackingUtils";
import { ChakraFlex as Flex, Icons } from "@airhelp/react-ui-components";
import { getPageUrl } from "utils/getPageUrl";
import { useLanguage } from "contexts/LocalizationContext";
import { config } from "./FunnelButton.config";

type Props = {
  type: "uploader" | "scanner";
};

export const FunnelButton = ({ type }: Props) => {
  const language = useLanguage();
  const { text, destination, icon, eventLabel } = config[type];

  const IconComponent = icon;

  const trackButton = () => {
    trackClickEvent("Hero", eventLabel);
  };

  return (
    <Flex
      mt={2}
      as="a"
      bgColor="greyscale.100"
      p={3}
      borderRadius="md"
      fontWeight="medium"
      alignItems="center"
      href={getPageUrl(language, destination)}
      onClick={trackButton}
    >
      <IconComponent boxSize={10} mr={3} borderRadius="sm" />
      {text}
      <Icons.AltArrowForward boxSize={6} color="primary.500" ml="auto" />
    </Flex>
  );
};
